<script setup>
import { useImage } from "#imports";
import { computed, inject } from "vue";
const props = defineProps({
  field: { type: [Object, String], required: false },
  currentBreakpoint: { type: String, required: false },
  background: { type: Boolean, required: false },
  breakpoint: { type: String, required: false },
  loading: { type: String, required: false },
  debug: { type: Boolean, required: false }
});
const emit = defineEmits([
  "load"
]);
const parentIsFirstElement = inject("parentIsFirstElement", false);
const renderFormat = computed(() => {
  return "Image";
});
function mediaLoaded() {
  emit("load", { src: props.field });
}
const mediaSource = computed(() => {
  if (!props.field)
    return null;
  if (typeof props.field === "object") {
    if (Array.isArray(props.field.value))
      return props.field.value[0]?.url || null;
    return props.field.value;
  }
  return props.field;
});
const nuxtImage = useImage();
const nuxtMediaSource = computed(() => {
  if (!props.field)
    return null;
  let src = props.field;
  if (typeof props.field === "object")
    src = props.field.url;
  return nuxtImage(src);
});
</script>

<template>
  <NuxtImg v-if="!background && mediaSource" :src="mediaSource" v-bind="$attrs" @load="mediaLoaded" />

  <slot
    v-else :image="nuxtMediaSource"
    v-bind="$attrs"
    :loading="parentIsFirstElement ? 'eager' : loading"
    :fetchpriority="parentIsFirstElement ? 'high' : 'auto'"
  />

  <div v-if="debug" class="space-y-4 mt-[25px] bg-white p-8 px-8 rounded-sm whitespace-pre-line break-words max-w-[100vw] overflow-x-scroll">
    <ClientOnly>
      <h1 class="text-2xl">
        Media String Debug
      </h1>
      <div>
        <strong>Source:</strong>
        <pre>{{ mediaSource }}</pre>
      </div>
      <div>
        <strong>Render Format:</strong>
        <pre>{{ renderFormat }}</pre>
      </div>
      <div>
        <strong>Background:</strong>
        <pre>{{ background }}</pre>
      </div>
      <div>
        <strong>Breakpoint:</strong>
        <pre>{{ breakpoint || "Not defined" }}</pre>
      </div>
      <div>
        <strong>Parent is first element:</strong>
        <pre>{{ parentIsFirstElement }}</pre>
      </div>
    </ClientOnly>
  </div>
</template>
